import React from 'react';

const WikiListItem = ({wiki}) => {
  let imgurl = 'doc.png';
  if (wiki.thumbnail) {
    imgurl = wiki.thumbnail.source;
  }
  return (
    <li className="list-group-item">
      <div className="media">
        <div className="media-left">
          <img className="media-object img-circle" src={imgurl} alt='...'/>
        </div>

        <div className="media-body">
          <h4 className="media-heading"><a href={`http://en.wikipedia.org/wiki/${wiki.title}`}
                                           target="_blank" rel="noopener noreferrer">{wiki.title}</a></h4>
          <div className="media-heading">{wiki.extract}</div>
        </div>
      </div>
    </li>
  );
};

export default WikiListItem;



// WEBPACK FOOTER //
// ./src/components/wiki_list_item.js